import Button from "@/components/common/Button";
import { useTranslation } from "react-i18next";

interface HeaderSectionProps {
  courses: any[];
  selectedCourse: string;
  onCourseChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const HeaderSection = ({ courses, selectedCourse, onCourseChange }: HeaderSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white/5 dark:bg-gray-800/50 backdrop-blur-sm border-b border-gray-200/20 dark:border-gray-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="flex flex-col gap-4">
          <div className="mb-2 sm:mb-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-white">
              {t("analytics.overview")}
            </h1>
            <p className="mt-1 sm:mt-2 text-sm sm:text-lg text-gray-300">
              {t("analytics.description")}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            {courses.length > 0 && (
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 flex-1">
                <label className="text-xs sm:text-sm font-medium text-gray-300 self-start sm:self-center">
                  {t("analytics.filterByCourse")}
                </label>
                <select
                  value={selectedCourse}
                  onChange={onCourseChange}
                  className="rounded-lg border border-gray-300 bg-white px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:focus:ring-offset-gray-800 w-full sm:min-w-[200px]"
                >
                  {courses.map((course) => (
                    <option key={course._id} value={course._id}>
                      {typeof course.title === "string"
                        ? course.title
                        : course.title?.en || course.title?.am || ""}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <Button
              variant="primary"
              size="sm"
              onClick={() => window.print()}
              className="whitespace-nowrap bg-green-600 hover:bg-green-700 border-green-600 w-full sm:w-auto text-xs sm:text-sm"
            >
              {t("analytics.export")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
